<template>
    <div class="d-flex justify-content-between align-items-center custom-checkbox custom-control-inline">
        <div
            class="btn-group-toggle"
            v-for="(day, dayIndex) in daysList"
            :key="dayIndex"
        >
            <label class="btn py-0" :style="[isActive(dayIndex) ? {'font-weight': 'bold', 'color': '#008CDD'} : {}]">
                <input type="checkbox" :value="day" v-model="readableSelection" @change="toggleDay($event, dayIndex)"> {{ $t(day) }}
            </label>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      daysList: [
        'components.core.days-modal-picker.monday',
        'components.core.days-modal-picker.tuesday',
        'components.core.days-modal-picker.wednesday',
        'components.core.days-modal-picker.thursday',
        'components.core.days-modal-picker.friday',
        'components.core.days-modal-picker.saturday',
        'components.core.days-modal-picker.sunday',
        'components.core.days-modal-picker.all'
      ],
      readableSelection: [],
      selectedDays: this.days
    }
  },
  props: {
    days: {
      default: '000000',
      type: String,
      required: false
    }
  },
  created () {
    let days = this.selectedDays.split('')
    days.forEach((day, index) => {
      if (day === '1') {
        this.readableSelection.push(this.daysList[index])
      }
    })
  },
  methods: {
    isActive (index) {
      if (!this.selectedDays) {
        return false
      } else {
        let days = this.selectedDays.split('')
        return days[index] === '1'
      }
    },
    toggleDay (e, index) {
      if (index === 7) {
        this.selectedDays = '1111111'
        this.readableSelection = []
        // We need this, so we can uncheck the checkboxes
        for (let key in this.daysList) {
          this.readableSelection.push(this.daysList[key])
        }
      } else {
        let days = this.selectedDays.split('')
        days[index] = (e.target.checked) ? '1' : '0'
        this.selectedDays = days.join('')
      }
    }
  },
  watch: {
    selectedDays (val) {
      this.$emit('update:days', val)
    }
  }
}
</script>

<style scoped>
    .btn {
        box-shadow: none;
        padding: .84rem;
        margin: 0;
        text-transform: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/core/DaysPicker.vue